import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowUp, Package, Clock, CheckCircle2, XCircle, Truck } from 'lucide-react';
import EnhancedReceiving from './EnhancedReceiving';
import PickingFulfillment from './PickingFulfillment';

const WarehouseOperations = () => {
  const [activeView, setActiveView] = useState('receiving');

  const receivingOrders = [
    { id: 1, po: 'PO-2024-089', supplier: 'Tech Solutions Ltd', items: 45, status: 'in-progress', expected: 'Today 2:00 PM', received: 38 },
    { id: 2, po: 'PO-2024-092', supplier: 'Office Supplies Co', items: 120, status: 'pending', expected: 'Today 4:00 PM', received: 0 },
    { id: 3, po: 'PO-2024-095', supplier: 'Furniture World', items: 25, status: 'completed', expected: 'Yesterday', received: 25 },
  ];

  const shippingOrders = [
    { id: 1, order: 'ORD-2024-156', customer: 'ABC Corporation', items: 12, status: 'picking', priority: 'high', due: 'Today 3:00 PM' },
    { id: 2, order: 'ORD-2024-157', customer: 'XYZ Industries', items: 8, status: 'packing', priority: 'medium', due: 'Today 5:00 PM' },
    { id: 3, order: 'ORD-2024-158', customer: 'Global Trading', items: 25, status: 'ready', priority: 'low', due: 'Tomorrow' },
  ];

  return (
    <div className="space-y-6">
      {/* View Toggle */}
      <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
        {[
          { id: 'receiving', label: 'Receiving', icon: ArrowDown },
          { id: 'shipping', label: 'Shipping', icon: ArrowUp },
          { id: 'transfers', label: 'Transfers', icon: Package },
        ].map((view) => {
          const Icon = view.icon;
          return (
            <button
              key={view.id}
              onClick={() => setActiveView(view.id)}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-md transition-colors ${
                activeView === view.id
                  ? 'bg-white text-orange-700 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <Icon className="w-4 h-4" />
              {view.label}
            </button>
          );
        })}
      </div>

      {/* Enhanced Receiving View */}
      {activeView === 'receiving' && (
        <EnhancedReceiving />
      )}

      {/* Picking & Fulfillment View */}
      {activeView === 'shipping' && (
        <PickingFulfillment />
      )}

      {/* Legacy Shipping View (Fallback - commented out) */}
      {false && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {['picking', 'packing', 'ready'].map((status) => (
            <div key={status} className="bg-white rounded-xl shadow-sm border border-gray-200">
              <div className="p-4 border-b border-gray-200">
                <h3 className="font-semibold text-gray-900 capitalize">{status}</h3>
                <p className="text-sm text-gray-500">
                  {shippingOrders.filter(o => o.status === status).length} orders
                </p>
              </div>
              <div className="p-4 space-y-3">
                {shippingOrders
                  .filter(o => o.status === status)
                  .map((order) => (
                    <div key={order.id} className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                      <div className="flex items-start justify-between mb-2">
                        <div>
                          <p className="font-semibold text-gray-900">{order.order}</p>
                          <p className="text-sm text-gray-600">{order.customer}</p>
                        </div>
                        <span className={`text-xs px-2 py-1 rounded ${
                          order.priority === 'high' ? 'bg-red-100 text-red-700' :
                          order.priority === 'medium' ? 'bg-yellow-100 text-yellow-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {order.priority}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-600">{order.items} items</span>
                        <span className="text-gray-500">{order.due}</span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Transfers View */}
      {activeView === 'transfers' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Stock Transfers</h3>
          <div className="text-center py-12 text-gray-500">
            <Package className="w-12 h-12 mx-auto mb-3 text-gray-400" />
            <p>No active transfers</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WarehouseOperations;
